// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: models/org.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Geo, geoFromJSON, geoToJSON } from "./global";
import { Metadata } from "./types";
import { SignUp, User, UserPreferences } from "./user";

export const protobufPackage = "models";

/**
 * NewOrgRequest allows a new user to add a new organization, default-tenant of that new organization and
 * first admin of that default-tenant.  The user making the NewOrgRequest must be new to the system and
 * user_preferences indicates the UserPreferences of this new user.  If an org with this name already exists,
 * the entire operation is aborted and an error is returned.  The UserAccessToken sent with the request
 * must have values for email and sub claims, but must not have values for org_id or tenant_id claims
 * (where the value of the email claim is the email of the new user).  The UserAccessToken returned with
 * the response will have values for email, sub, org_id and tenant_id claims.
 */
export interface NewOrgRequest {
  /** Information about the company and the indvidual signing up. */
  signUp:
    | SignUp
    | undefined;
  /** User preferences of the first admin user of new default-tenant. */
  userPreferences:
    | UserPreferences
    | undefined;
  /** Target geo for org creation. */
  targetGeo: Geo;
}

/** Response to NewOrgRequest. */
export interface NewOrgResponse {
  /** The globally unique identifier of the new organization just created. */
  id: string;
  /** Description of the first admin user of the new default-tenant. */
  user:
    | User
    | undefined;
  /**
   * User preferences of the first admin user of the new default-tenant.
   *
   * @deprecated
   */
  userPreferences: UserPreferences | undefined;
}

export interface Organization {
  id: string;
  name: string;
  optInC3: boolean;
  metadata: Metadata | undefined;
}

function createBaseNewOrgRequest(): NewOrgRequest {
  return { signUp: undefined, userPreferences: undefined, targetGeo: 0 };
}

export const NewOrgRequest: MessageFns<NewOrgRequest> = {
  encode(message: NewOrgRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.signUp !== undefined) {
      SignUp.encode(message.signUp, writer.uint32(10).fork()).join();
    }
    if (message.userPreferences !== undefined) {
      UserPreferences.encode(message.userPreferences, writer.uint32(18).fork()).join();
    }
    if (message.targetGeo !== 0) {
      writer.uint32(24).int32(message.targetGeo);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NewOrgRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNewOrgRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.signUp = SignUp.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.userPreferences = UserPreferences.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.targetGeo = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NewOrgRequest {
    return {
      signUp: isSet(object.signUp) ? SignUp.fromJSON(object.signUp) : undefined,
      userPreferences: isSet(object.userPreferences) ? UserPreferences.fromJSON(object.userPreferences) : undefined,
      targetGeo: isSet(object.targetGeo) ? geoFromJSON(object.targetGeo) : 0,
    };
  },

  toJSON(message: NewOrgRequest): unknown {
    const obj: any = {};
    if (message.signUp !== undefined) {
      obj.signUp = SignUp.toJSON(message.signUp);
    }
    if (message.userPreferences !== undefined) {
      obj.userPreferences = UserPreferences.toJSON(message.userPreferences);
    }
    if (message.targetGeo !== 0) {
      obj.targetGeo = geoToJSON(message.targetGeo);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NewOrgRequest>, I>>(base?: I): NewOrgRequest {
    return NewOrgRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NewOrgRequest>, I>>(object: I): NewOrgRequest {
    const message = createBaseNewOrgRequest();
    message.signUp = (object.signUp !== undefined && object.signUp !== null)
      ? SignUp.fromPartial(object.signUp)
      : undefined;
    message.userPreferences = (object.userPreferences !== undefined && object.userPreferences !== null)
      ? UserPreferences.fromPartial(object.userPreferences)
      : undefined;
    message.targetGeo = object.targetGeo ?? 0;
    return message;
  },
};

function createBaseNewOrgResponse(): NewOrgResponse {
  return { id: "", user: undefined, userPreferences: undefined };
}

export const NewOrgResponse: MessageFns<NewOrgResponse> = {
  encode(message: NewOrgResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.user !== undefined) {
      User.encode(message.user, writer.uint32(18).fork()).join();
    }
    if (message.userPreferences !== undefined) {
      UserPreferences.encode(message.userPreferences, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NewOrgResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNewOrgResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.user = User.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.userPreferences = UserPreferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NewOrgResponse {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      user: isSet(object.user) ? User.fromJSON(object.user) : undefined,
      userPreferences: isSet(object.userPreferences) ? UserPreferences.fromJSON(object.userPreferences) : undefined,
    };
  },

  toJSON(message: NewOrgResponse): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.user !== undefined) {
      obj.user = User.toJSON(message.user);
    }
    if (message.userPreferences !== undefined) {
      obj.userPreferences = UserPreferences.toJSON(message.userPreferences);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NewOrgResponse>, I>>(base?: I): NewOrgResponse {
    return NewOrgResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NewOrgResponse>, I>>(object: I): NewOrgResponse {
    const message = createBaseNewOrgResponse();
    message.id = object.id ?? "";
    message.user = (object.user !== undefined && object.user !== null) ? User.fromPartial(object.user) : undefined;
    message.userPreferences = (object.userPreferences !== undefined && object.userPreferences !== null)
      ? UserPreferences.fromPartial(object.userPreferences)
      : undefined;
    return message;
  },
};

function createBaseOrganization(): Organization {
  return { id: "", name: "", optInC3: false, metadata: undefined };
}

export const Organization: MessageFns<Organization> = {
  encode(message: Organization, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.optInC3 !== false) {
      writer.uint32(24).bool(message.optInC3);
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Organization {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrganization();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.optInC3 = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Organization {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      optInC3: isSet(object.optInC3) ? globalThis.Boolean(object.optInC3) : false,
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
    };
  },

  toJSON(message: Organization): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.optInC3 !== false) {
      obj.optInC3 = message.optInC3;
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Organization>, I>>(base?: I): Organization {
    return Organization.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Organization>, I>>(object: I): Organization {
    const message = createBaseOrganization();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.optInC3 = object.optInC3 ?? false;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
